export function shorteningAddress(address: string, rightSideOnly: boolean = false): string {
    return `${rightSideOnly ? '' : address.slice(0, 4) + ' '}···· ${address.slice(-4)}`;
};